import { render, staticRenderFns } from "./RankingOfExcellence.vue?vue&type=template&id=ff923320"
import script from "./RankingOfExcellence.vue?vue&type=script&lang=js"
export * from "./RankingOfExcellence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports